import React from 'react';

export default function PageHeading(props) {
    const heading_text = props.heading_text
    const image_url = props.image_url || '/images/showroom.jpg';
    return (
      <>
        <div className='image-heading' style={{backgroundImage: `url(${image_url})` }}>
        <div className="heading-frame">
                        

                        <h2 className="text-center heading-text">{heading_text}
                        <div className="border-frame tr"></div>
                        <div className="border-frame bl"></div>
                        </h2>

                        
                      </div>
        </div>
      </>
    );
  }